import { render } from "./AgingBags.vue?vue&type=template&id=19a79c04&scoped=true"
import script from "./AgingBags.vue?vue&type=script&lang=js"
export * from "./AgingBags.vue?vue&type=script&lang=js"

import "./AgingBags.vue?vue&type=style&index=0&id=19a79c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a79c04"]])

export default __exports__